export default {
  initial: 1,
  eco: 2,
  variant: 3,
  rebrand: 58
};



// WEBPACK FOOTER //
// ./src/dictionaries/ReqTypes.js